// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

// carz blog specific JS
require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_carz_footer_menu_trigger')
require('../site_scripts/mtc_scroll_to_section')
require('../site_scripts/mtc_add_this_on_demand');
require('../site_scripts/mtc_share_options')

require('../carz_script.js')

// carz homepage specific styles
require('../../css/carz_blog.less')
